/**
 * Standalone percent formatter used in both the grid cell and the
 * adoption tiles in `FlagDetailDrawer`. Kept tiny and predictable so
 * tests can pin the rounding behavior in one place.
 *
 * For a non-zero numerator that rounds to 0%, show "<1%" so reviewers
 * don't misread it as "no tenants at all". When the denominator is 0
 * (no customer tenants), return "—" so the cell renderer can fall back
 * to the raw count without showing `NaN%`.
 */
export function formatPercent(numerator: number, denominator: number): string {
  if (denominator <= 0) return "—";
  if (numerator <= 0) return "0%";
  const pct = (numerator / denominator) * 100;
  if (pct < 1) return "<1%";
  return `${Math.round(pct)}%`;
}

/**
 * Drop a trailing " module" word from a flag label so it reads cleanly
 * inside the Parent module column (whose header already says "Parent
 * module"). Case-insensitive, requires whitespace before "module" so
 * legitimate words like "Submodule" stay intact.
 *
 * Returns the original label if stripping would produce an empty
 * string (e.g. a label that's literally just "Module").
 */
export function stripModuleSuffix(label: string): string {
  const stripped = label.replace(/\s+module$/i, "").trim();
  return stripped.length > 0 ? stripped : label;
}
